import React, { useEffect } from "react";
import { Flex, Center, Text, Image } from "@chakra-ui/react";
import { useHistory, useLocation } from "react-router-dom";
import qs from "qs";
import iconSuccess from "assets/images/success-circle.svg";
import iconError from "assets/images/error-triangle.svg";
import LoadingOverlay from "components/LoadingOverlay";
import { useActivateAccountMutation } from "redux/services/identity";

const ActivateAccount: React.FC<{ isForceSuccess?: boolean }> = ({
  isForceSuccess,
}) => {
  const { push } = useHistory();
  const { search } = useLocation();
  const [activateAccountMutation, { isSuccess, isError, isLoading }] =
    useActivateAccountMutation();

  useEffect(() => {
    const { code, activateToken }: any = qs.parse(search.replace("?", ""));

    activateAccountMutation({
      verificationCode: code,
      activateToken,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    const { callback }: any = qs.parse(search.replace("?", ""));
    if (callback) {
      const url = new URL(callback);
      const passwordToken = url.searchParams.get("passwordToken");

      if (isForceSuccess || isSuccess) {
        const timeoutRedirect = setTimeout(() => {
          push(`/set-password?passwordToken=${passwordToken}&scenario=set-password`);
          clearTimeout(timeoutRedirect);
        }, 1500);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, push]);

  return (
    <Center
      className="Register"
      w="100%"
      h="100%"
      overflow="auto"
      mt="0 !important"
      p={["24px 15px", null, 0]}
    >
      {isLoading ? (
        <LoadingOverlay h="100%" />
      ) : (
        <Flex
          flexDir="column"
          h="100%"
          w={["100%", "364px"]}
          justify={["flex-start", null, "center"]}
        >
          <Image
            mt="52px"
            mb="30px"
            src={isForceSuccess || isSuccess ? iconSuccess : iconError}
            alt="Success"
            loading="lazy"
          />
          {(isForceSuccess || isSuccess) && (
            <>
              <Text textAlign="center" textStyle="h2">
                Your account is confirmed!
              </Text>
              <Text mt="5px" textAlign="center" textStyle="h5">
                You will be redirected to another screen to set your password
              </Text>
            </>
          )}
          {isError && (
            <>
              <Text textAlign="center" color="red" textStyle="h2">
                Provided link is invalid or expired.
              </Text>
            </>
          )}
        </Flex>
      )}
    </Center>
  );
};

export default ActivateAccount;
